import ViewPermissions from "../components/Permission/ViewPermission";

const PermissionsViewPage: React.FC = () => {
  return <ViewPermissions />;
};

export default PermissionsViewPage;
